import { render, staticRenderFns } from "./vRecoverPassword.vue?vue&type=template&id=f4a7c5ce&"
import script from "./vRecoverPassword.vue?vue&type=script&lang=js&"
export * from "./vRecoverPassword.vue?vue&type=script&lang=js&"
import style0 from "./vRecoverPassword.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports